var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.message?.text
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("p", [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.message.text) } }),
              _vm._v(" "),
              _vm.message.date
                ? _c("strong", [
                    _vm._v(
                      _vm._s(_vm.printDate(_vm.message.date, "DD.MM.YYYY"))
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }